export function Logo({ className = "h-8 w-8" }) {
  return (
    <img
      src="/logo.png"
      alt="Systech Aqua Solutions logo"
      className={`${className} object-contain mix-blend-multiply`}
    />
  );
}
